import { render, staticRenderFns } from "./IotSensorReadItemList.vue?vue&type=template&id=47f0fb17&scoped=true&"
import script from "./IotSensorReadItemList.vue?vue&type=script&lang=js&"
export * from "./IotSensorReadItemList.vue?vue&type=script&lang=js&"
import style0 from "./IotSensorReadItemList.vue?vue&type=style&index=0&id=47f0fb17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f0fb17",
  null
  
)

export default component.exports